import { Flex, Heading, Stack, Text } from "@chakra-ui/react";
import React from "react";

export default function Banner() {
  return (
    <Flex
      bgImage={"url('/images/trust-matters/banner.png')"}
      height="400px"
      bgSize={"cover"}
      bgRepeat="no-repeat"
      justifyContent={"start"}
      alignItems="center"
      flexDirection="column"
      color="white"
      gap={5}
      backgroundPosition="center"
      my={10}
    >
      <Stack alignItems="center" mt={20} maxW={"430px"}>
        <Heading fontWeight={"semibold"} fontSize={{base:"22px",lg:"28px"}}>Trust Matters Most</Heading>
        <Text color="brand.100" fontSize={{base:"17px",lg:"23px"}} align="center">
          Millions of Gigs. Millions of users. But your trust & safety is our #1
          priority.
        </Text>
        <Text textDecoration={"underline"}>Join Decolance</Text>
      </Stack>
    </Flex>
  );
}
